import { render, staticRenderFns } from "./simulationFrais.vue?vue&type=template&id=0b549b47&scoped=true&"
import script from "./simulationFrais.vue?vue&type=script&lang=js&"
export * from "./simulationFrais.vue?vue&type=script&lang=js&"
import style0 from "./simulationFrais.vue?vue&type=style&index=0&id=0b549b47&scoped=true&lang=scss&"
import style1 from "./simulationFrais.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b549b47",
  null
  
)

export default component.exports